import { useAtom } from '@reatom/npm-react'
import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { NumericFormat } from '@root/shared/core/format'
import { BackingIcon } from '@root/shared/ui-kit'

import { PairStatsPanelTopRowItem } from './pair-stats-panel-top-row-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const PairStatsPanelDevHolding: React.FC<Props> = memo(({ pair }) => {
  const { t } = useTranslation()
  const [audit] = useAtom(pair.audit)

  const percent = audit.checks.ownerTokenBalance.percent
  const formatted = useMemo(
    () => NumericFormat.formatPreset(percent, 'percents'),
    [percent],
  )

  return (
    <PairStatsPanelTopRowItem
      title={t('trading.audit.dev_holding.short')}
      intent={audit.checks.ownerTokenBalance.status}
      icon={BackingIcon}
      tooltip={t('trading.audit.dev_holding_tooltip', {
        percentage: formatted,
      })}
      value={<FlashTextContentDistinct>{formatted}%</FlashTextContentDistinct>}
    />
  )
})
